import { Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<void, 'rightSection'>()(
  (theme: Theme, _params, classes) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
    },
    nameContainer: {
      display: 'flex',
      gap: theme.spacing(1.5),
      alignItems: 'center',
    },
    templateName: {
      color: theme.palette.select.light,
      fontFamily: theme.typography.fontFamily,
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '20px',
      letterSpacing: '0.1px',
      textDecoration: 'none',
    },
    templateDetailsText: {
      color: theme.palette.textField.dark,
      fontFamily: theme.typography.fontFamily,
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.25px',
    },
    templateType: {
      color: theme.palette.textField.main,
      fontFamily: theme.typography.fontFamily,
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.25px',
    },
    rightSection: {
      display: 'flex',
      gap: theme.spacing(1.5),
      alignItems: 'center',
    },
    icon: {
      width: theme.spacing(2),
      height: theme.spacing(2),
      fontSize: '16px',
      padding: theme.spacing(0, 0.5, 0, 0),
      color: theme.palette.select.light,
    },
    cloneModalContentContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(5),
    },
    heading: {
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      color: theme.palette.labraText.description,
      fontFamily: theme.typography.fontFamily,
      letterSpacing: '0.25px',
    },
  })
)
